/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');
var LicenseHeaderBarView = require('../../common/views/LicenseHeaderBarView');
var tmplLicenseDBAEditFormView = require('../templates/LicenseDBAEditFormView.hbs');
var LicenseDBAEditApplicationView = require('../forms/LicenseDBAEditApplication/LicenseDBAEditApplicationView');

module.exports = Marionette.LayoutView.extend({
  template: tmplLicenseDBAEditFormView,

  className: 'license-dba-edit-form-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    licenseDBAEditFormContainer: '.license-dba-edit-form-container'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadCrumbContainer: '@ui.breadCrumbContainer',
    licenseDBAEditFormContainer: '@ui.licenseDBAEditFormContainer'
  },

  templateHelpers: function() {
    return {
      viewMode: this.options.viewMode
    };
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var licenseId = this.model.get('licenseId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');
    var licenseType = modelGet(this.model, 'licenseIdentifiers.licenseType');
    var licenseNumber = modelGet(this.model, 'licenseIdentifiers.licenseNumber');
    var existingDBAs = this.model.get('licenseDBAs');

    this.showChildView(
      'headerBarContainer',
      new LicenseHeaderBarView({
        model: new Backbone.Model(this.model.get('licenseIdentifiers'))
      })
    );

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#ext/nondep/dashboard'
          },
          {
            text: entityName,
            link: '#ext/nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'License #' + licenseNumber + ' - ' + licenseType,
            link: '#ext/nondep/entity/' + entityId + '/license/' + licenseId
          },
          {
            text: 'Apply to Edit D/B/A'
          }
        ]
      })
    );

    this.showChildView(
      'licenseDBAEditFormContainer',
      new LicenseDBAEditApplicationView({
        isReadOnly: false,
        model: this.model
      })
    );

    Radio.channel('nd:submit-application').on('submit', function() {
      Radio.channel('navigate').trigger('show:ext:nd:license-dashboard', entityId, licenseId, entityName, existingDBAs);
    });
  }
});
